import { dashboardConstants } from "../actions/constants/dashboardConstants";

export const getCommonReportsReducer = (state = {}, action: any) => {
  switch (action.type) {
    case dashboardConstants.getCommonReportsRequest:
      return {
        isLoading: true,
        isSuccess: false,
        isError: false,
      };
    case dashboardConstants.getCommonReportsSuccess:
      return {
        isLoading: false,
        isSuccess: true,
        isError: false,
        data: action.payload,
      };
    case dashboardConstants.getCommonReportsFailure:
      return {
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const getRevenueReportReducer = (state = {}, action: any) => {
  switch (action.type) {
    case dashboardConstants.getRevenueReportRequest:
      return {
        isLoading: true,
        isSuccess: false,
        isError: false,
      };
    case dashboardConstants.getRevenueReportSuccess:
      return {
        isLoading: false,
        isSuccess: true,
        isError: false,
        data: action.payload,
      };
    case dashboardConstants.getRevenueReportFailure:
      return {
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const getStudentReportReducer = (state = {}, action: any) => {
  switch (action.type) {
    case dashboardConstants.getStudentReportRequest:
      return {
        isLoading: true,
        isSuccess: false,
        isError: false,
      };
    case dashboardConstants.getStudentReportSuccess:
      return {
        isLoading: false,
        isSuccess: true,
        isError: false,
        data: action.payload,
      };
    case dashboardConstants.getStudentReportFailure:
      return {
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const getInstructorReportReducer = (state = {}, action: any) => {
  switch (action.type) {
    case dashboardConstants.getInstructorReportRequest:
      return {
        isLoading: true,
        isSuccess: false,
        isError: false,
      };
    case dashboardConstants.getInstructorReportSuccess:
      return {
        isLoading: false,
        isSuccess: true,
        isError: false,
        data: action.payload,
      };
    case dashboardConstants.getInstructorReportFailure:
      return {
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};
